/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import Avatar from '@deprecated-ui/common/Avatar';
import color from '@deprecated-ui/_style/color';
import { AVATAR_URL } from 'constants/api';
import StreamTabAnalytics, {
  PAGE_SOURCE,
} from 'features/stream/analytics/StreamTabAnalytics';
import Image from 'global/Image';
import { LabelVerifiedAccount } from 'global/Labels';
import Link from 'next/link';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleErrorAvatar } from 'utils/general';
import { useRouter } from 'next/router';
import {
  mainProfileEvents,
  PAGE_SOURCE_INDEX,
  PAGE_SOURCE as PROFILE_PAGE_SOURCE,
} from 'features/user/analytics/ProfileAnalytics';
import { effects } from '../../slice';
import { UserItemContainer } from './styled';

interface UserItemProp {
  user: {
    about: string;
    avatar: string;
    email: string;
    followed: boolean;
    fullname: string;
    id: string;
    tren_trending: string;
    username: string;
    is_verified: boolean;
  };
  postid: number;
  hasButton?: boolean;
}

const pageSourceIndex = PAGE_SOURCE_INDEX.findIndex(
  (x) => x === 'Stream Like List',
);

function UserItem({ user, postid, hasButton }: UserItemProp) {
  const { avatar, id, username, fullname, followed } = user;

  const dispatch = useDispatch();
  const router = useRouter();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const buttonType = followed ? 'default' : 'outline-primary';
  const followingText = followed ? 'Following' : 'Follow';

  const handleFollowUser = async () => {
    StreamTabAnalytics.common.Action.clickFollowButton(PAGE_SOURCE.LIKES);

    const data = {
      postid,
      userid: id,
      type: followed === false ? 'FOLLOW' : 'UNFOLLOW',
    };

    setIsLoading(true);
    // @ts-ignore
    const follow = await dispatch(effects.followStreamLikers(data));

    // @ts-ignore;
    const { error } = follow.payload;

    if (!error) {
      setIsLoading(false);
    }
  };

  const handleClickUserProfile = (e) => {
    e.preventDefault();
    StreamTabAnalytics.common.Action.clickProfile(PAGE_SOURCE.LIKES);

    mainProfileEvents.onViewProfile(PROFILE_PAGE_SOURCE.streamLikeList);

    // navigate to user profile
    router.push(`/${username}?source=${pageSourceIndex}`, undefined, {
      shallow: true,
    });
  };

  const avatarUrl = avatar?.startsWith('http')
    ? avatar
    : `${AVATAR_URL}/${avatar}`;

  return (
    <UserItemContainer>
      {/* @ts-expect-error */}
      <Flex align="center" mr="20px">
        {/* @ts-expect-error */}
        <Avatar size="small" mr="16px">
          <Image
            src={avatarUrl}
            onError={(e) => handleErrorAvatar(e, username)}
          />
        </Avatar>
        <div>
          <Flex align="center">
            <Link href={`/${username}?source=${pageSourceIndex}`} passHref>
              <a
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClickUserProfile}
              >
                <Text family="bold">{username}</Text>
              </a>
            </Link>
            <LabelVerifiedAccount deprecatedVerifiedStatus={user.is_verified} />
          </Flex>

          {fullname && (
            <Text color={color.suvaGrey}>{fullname.substr(0, 100)}</Text>
          )}
        </div>
      </Flex>
      {hasButton && (
        <Button
          type={buttonType}
          height="32px"
          width="100px"
          onClick={handleFollowUser}
          style={{ flexShrink: '0' }}
          loading={isLoading}
          disabled={isLoading}
          radius="4px"
        >
          <Text family="bold" color="inherit">
            {followingText}
          </Text>
        </Button>
      )}
    </UserItemContainer>
  );
}

export default UserItem;
